import { FieldSet, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';

import { AUTO_FREQUENCY, MANUAL_FREQUENCY } from '@renter-hub/constants/paymentConstants';

interface Props {
  legend: string;
  frequencyType: string;
  setFrequencyType: (frequencyType: string) => void;
}

const PaymentFrequencyPage = ({ legend, setFrequencyType, frequencyType }: Props) => (
  <FieldSet legend={<Legend size="lg">{legend}</Legend>}>
    <LabeledControl
      control={
        <Radio
          name="frequencyType"
          value={AUTO_FREQUENCY}
          checked={frequencyType === AUTO_FREQUENCY}
          onChange={() => setFrequencyType(AUTO_FREQUENCY)}
        />
      }
      label={<Label>Autopay/recurring</Label>}
    />
    <LabeledControl
      control={
        <Radio
          name="frequencyType"
          value={MANUAL_FREQUENCY}
          checked={frequencyType === MANUAL_FREQUENCY}
          onChange={() => setFrequencyType(MANUAL_FREQUENCY)}
        />
      }
      label={<Label>One at a time</Label>}
    />
  </FieldSet>
);

export default PaymentFrequencyPage;
